// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  user-select: text;
  -webkit-user-select: text;
}

.close-icon {
  position: absolute;
  top: 10px;
  right: 10px;
}

.hero {
  padding: 30px 25px 25px;
  color: var(--ion-color-main);
  text-align: left;
}
.hero h1 {
  font-family: AppFontSemiBold, sans-serif;
  font-size: 22px;
  line-height: 33px;
  text-transform: uppercase;
  margin: 10px 0px 5px;
}
.hero p {
  font-family: AppFontLight, sans-serif;
  color: rgba(47, 51, 58, 0.7);
  font-size: 14px;
  margin-top: 5px;
  margin-bottom: 15px;
}

.search-bar ion-input {
  color: var(--ion-color-main) !important;
  --color: var(--ion-color-main);
  font-size: 15px !important;
  font-weight: 600; /* Make text bolder */
  --padding-top: 20px;
  --padding-bottom: 20px;
  --padding-start: 10px;
  --padding-end: 10px;
  /* Styles for the host interaction */
  user-select: text !important;
  -webkit-user-select: text !important;
  /* Target the native input inside Shadow DOM */
}
.search-bar ion-input::part(native) {
  caret-color: #474030 !important; /* Use dark color from theme instead of light primary */
  caret-width: 2px !important; /* Make caret thicker */
  user-select: text !important;
  -webkit-user-select: text !important;
  pointer-events: auto !important;
  opacity: 1 !important;
  font-weight: 600 !important;
}

.search-bar {
  border: 1px solid #e5e5e5;
  border-radius: 7px;
  --background: #ffffff;
  background: #ffffff;
  overflow: hidden;
  transition: border-color 0.2s, box-shadow 0.2s;
  /* Layout replacement */
  display: flex;
  align-items: center;
  padding-left: 10px;
  padding-right: 10px;
}
.search-bar:focus-within {
  border-color: var(--ion-color-primary);
  box-shadow: 0 0 0 1px var(--ion-color-primary);
}

.search-bar ion-input {
  flex: 1;
  --background: transparent;
}

.start-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
  /* Reset other margins if needed */
  margin-inline-end: 5px;
}

.search-container ion-col {
  padding: 0 !important;
  border-radius: var(--ion-border-radius);
}

.no-place {
  padding: 16px 9px;
  font-family: AppFont-bold, sans-serif;
  background: #ffffff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: var(--ion-border-radius);
  font-size: 12px;
  line-height: 131.5%;
}

.suggested-place {
  border-radius: 7px;
  border: 1px solid #d5dddd;
  background: #f7f9f9;
  place-items: center;
  padding: 15px 20px;
  margin-top: 5px;
  text-align: left;
}
.suggested-place .navigate-icon {
  margin-right: 15px;
  fill: var(--ion-color-primary) !important;
}
.suggested-place .actual-position-title {
  font-size: 14px;
  line-height: 17px;
  text-transform: uppercase;
  color: var(--ion-color-primary);
  font-family: AppFontSemiBold, sans-serif;
}
.suggested-place .actual-position {
  font-size: 13px;
  margin-top: 5px;
  line-height: 16px;
  color: #6d7075;
  font-family: AppFontLight, sans-serif;
}

#buttonContainer {
  position: absolute;
  width: 100%;
  bottom: 0;
}

.vertical-space-around {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
}

.cnt-btn {
  width: 100%;
  padding: 16px;
  text-align: center;
  font-family: AppFontBold, sans-serif;
  color: white;
  font-weight: bold;
  text-transform: uppercase;
  cursor: pointer;
  margin: 0;
  background: var(--randy-red, #dd2e4e) !important;
  color: white !important;
  border: none;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 50px;
}
@media (min-width: 991px) {
  .cnt-btn {
    margin: auto;
  }
}

.geo-btn {
  background: #62aba4;
  font-family: AppFont-bold, sans-serif;
  color: #ffffff;
  font-weight: bold;
  cursor: pointer;
  width: 100%;
  padding: 16px;
  text-align: center;
  text-transform: uppercase;
  display: flex;
  justify-content: center;
  align-items: center;
}
.geo-btn ion-icon {
  width: 22px;
  height: 25px;
  margin-right: 10px;
}
@media (min-width: 991px) {
  .geo-btn {
    width: 600px;
    margin: auto;
  }
}

.heading-text {
  font-size: 19px;
  color: var(--ion-text-color);
  font-weight: 500;
  line-height: 145%;
  margin: 20px 0 10px;
}
.heading-text.desktop {
  display: block;
}
@media (max-width: 992px) {
  .heading-text.desktop {
    display: none;
  }
}
.heading-text.mobile {
  display: none;
}
@media (max-width: 992px) {
  .heading-text.mobile {
    display: block;
  }
}

.sub-heading {
  font-size: 18px;
  line-height: 134%;
  margin: 0;
}

.footer-btn {
  font-family: AppFontBold, sans-serif;
  text-transform: uppercase;
  color: white;
}

ion-footer,
.footer-btn {
  background: unset;
  padding: 5px 28px 25px !important;
  box-shadow: none;
}
@media (min-width: 991px) {
  ion-footer,
  .footer-btn {
    margin: 0px 50px 0 !important;
    width: calc(100% - 100px) !important;
  }
}
ion-footer .button,
.footer-btn .button {
  flex: 1;
  background: var(--ion-color-primary) !important;
  color: white !important;
  text-align: center;
}
ion-footer .button:first-child,
.footer-btn .button:first-child {
  margin-right: 3px;
}
ion-footer .button:last-child,
.footer-btn .button:last-child {
  margin-left: 3px;
}
ion-footer .button.active,
.footer-btn .button.active {
  transition: 0.3s linear;
  background: var(--ion-color-main);
  color: var(--ion-text-color);
}
ion-footer .button.active:hover,
.footer-btn .button.active:hover {
  transition: 0.3s linear;
  background: var(--ion-color-main);
}

.desktop {
  display: none;
  margin: 50px 25px;
}
@media (min-width: 991px) {
  .desktop {
    display: block;
  }
}
.desktop .hero {
  background: white;
  border: 0.5px solid #e5e5e5;
  box-shadow: 0px 4px 10px rgba(33, 33, 33, 0.02);
  border-radius: 10px;
}

.mobile {
  display: none;
}
@media (max-width: 992px) {
  .mobile {
    display: block;
  }
}

@media (min-width: 991px) {
  .desktop-hero {
    text-align: center;
    margin: 0px 25px 50px;
  }
}

.cross-icon-close {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}

.pac-container {
  background-color: #fff;
  border: 1px solid #d5dddd;
  border-top: none;
  border-radius: 0 0 7px 7px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  margin-top: -2px;
  position: relative;
  z-index: 100;
}

.pac-item {
  cursor: pointer;
  padding: 10px 15px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  line-height: 30px;
  text-align: left;
  border-top: 1px solid #e6e6e6;
  font-size: 14px;
  color: #333;
  display: flex;
  align-items: center;
}
.pac-item:hover {
  background-color: #fafafa;
}
.pac-item .pac-icon {
  width: 15px;
  height: 20px;
  margin-right: 7px;
  margin-top: -1px;
  display: inline-block;
  vertical-align: top;
  background-image: url(https://maps.gstatic.com/mapfiles/api-3/images/autocomplete-icons.png);
  background-size: 34px;
}
.pac-item .pac-icon-marker {
  background-position: -1px -161px;
}
.pac-item .pac-item-query {
  font-size: 14px;
  padding-right: 3px;
  color: #000;
}

.overlay-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.53);
  backdrop-filter: blur(5px);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.radius-alert-card {
  background: #fffaf1;
  border-radius: 6px;
  padding: 24px;
  width: 90%;
  max-width: 400px;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
.radius-alert-card h2 {
  font-family: AppFontBold, sans-serif;
  font-size: 20px;
  color: #1f2228;
  margin-bottom: 12px;
  margin-top: 0;
}
.radius-alert-card p {
  font-family: AppFontRegular, sans-serif;
  font-size: 12px;
  line-height: 140%;
  color: #1f2228;
  margin-bottom: 24px;
}
.radius-alert-card button {
  width: 100%;
  padding: 14px;
  margin-bottom: 12px;
  border-radius: 4px;
  font-family: AppFontBold, sans-serif;
  font-size: 16px;
  cursor: pointer;
  border: none;
  outline: none;
}
.radius-alert-card .btn-pickup {
  background: #dc3545;
  color: white;
}
.radius-alert-card .btn-pickup:active {
  opacity: 0.9;
}
.radius-alert-card .btn-cancel {
  background: white;
  color: #1f2228;
  border: 1px solid #c4c4c4;
}
.radius-alert-card .btn-cancel:active {
  background-color: #f9f9f9;
}

.error-row {
  background-color: #ed6958;
  padding: 16px 35px;
  border-radius: 5px;
  position: relative;
  margin-top: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  /* Add the little arrow (triangle) pointing up */
}
.error-row .error-message {
  font-size: 14px;
  text-align: center;
  color: #fff;
  text-transform: capitalize;
  margin: 0;
}
.error-row::before {
  content: "";
  position: absolute;
  top: -16px;
  left: 50%;
  border-width: 8px;
  border-style: solid;
  border-color: transparent transparent #e85c4a transparent;
  transform: translate(-50%, 0px);
}`, "",{"version":3,"sources":["webpack://./src/app/components/check-delivery-radius-modal/check-delivery-radius-modal.component.scss"],"names":[],"mappings":"AAYA;EACC,iBAAA;EACA,yBAAA;AAXD;;AAcA;EACC,kBAAA;EACA,SAAA;EACA,WAAA;AAXD;;AAcA;EACC,uBAAA;EACA,4BAAA;EACA,gBAAA;AAXD;AAYC;EACC,wCAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,oBAAA;AAVF;AAYC;EACC,qCAAA;EACA,4BAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;AAVF;;AAcA;EACC,uCAAA;EACA,8BAAA;EACA,0BAAA;EACA,gBAAA,EAAA,qBAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;EAEA,oCAAA;EACA,4BAAA;EACA,oCAAA;EAEA,8CAAA;AAbD;AAcC;EACC,+BAAA,EAAA,uDAAA;EACA,2BAAA,EAAA,uBAAA;EACA,4BAAA;EACA,oCAAA;EACA,+BAAA;EACA,qBAAA;EACA,2BAAA;AAZF;;AAeA;EACC,yBAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,8CACC;EAGD,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AAfD;AAiBC;EACC,sCAAA;EACA,8CAAA;AAfF;;AAmBA;EACC,OAAA;EACA,yBAAA;AAhBD;;AAmBA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kCAAA;EACA,sBAAA;AAhBD;;AAmBA;EACC,qBAAA;EACA,uCAAA;AAhBD;;AAmBA;EACC,iBAAA;EACA,qCAAA;EACA,mBAAA;EACA,yCAAA;EACA,uCAAA;EACA,eAAA;EACA,mBAAA;AAhBD;;AAmBA;EACC,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AAhBD;AAiBC;EACC,kBAAA;EACA,yCAAA;AAfF;AAkBC;EACC,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,+BAAA;EACA,wCAAA;AAhBF;AAmBC;EACC,eAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,qCAAA;AAjBF;;AAqBA;EACC,kBAAA;EACA,WAAA;EACA,SAAA;AAlBD;;AAqBA;EACC,YAAA;EACA,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,mBAAA;AAlBD;;AAqBA;EACC,WAAA;EACA,aAAA;EACA,kBAAA;EACA,oCAAA;EACA,YAAA;EACA,iBAAA;EAEA,yBAAA;EACA,eAAA;EACA,SAAA;EACA,gDAAA;EACA,uBAAA;EACA,YAAA;EACA,wCAAA;EACA,mBAAA;AAnBD;AA9JC;EAkKD;IAiBE,YAAA;EAjBA;AACF;;AAoBA;EACC,mBAAA;EACA,qCAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EAEA,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAlBD;AAoBC;EACC,WAAA;EACA,YAAA;EACA,kBAAA;AAlBF;AAvLC;EAuLD;IAsBE,YAAA;IACA,YAAA;EAlBA;AACF;;AAqBA;EACC,eAAA;EACA,4BAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAlBD;AAoBC;EACC,cAAA;AAlBF;AAlMC;EAmNA;IAGE,aAAA;EAhBD;AACF;AAmBC;EACC,aAAA;AAjBF;AA1MC;EA0NA;IAGE,cAAA;EAfD;AACF;;AAmBA;EACC,eAAA;EACA,iBAAA;EACA,SAAA;AAhBD;;AAmBA;EACC,oCAAA;EACA,yBAAA;EACA,YAAA;AAhBD;;AAmBA;;EAEC,iBAAA;EACA,iCAAA;EACA,gBAAA;AAhBD;AAxOC;EAoPD;;IAOE,6BAAA;IACA,oCAAA;EAdA;AACF;AAgBC;;EACC,OAAA;EACA,+CAAA;EACA,uBAAA;EACA,kBAAA;AAbF;AAeE;;EACC,iBAAA;AAZH;AAeE;;EACC,gBAAA;AAZH;AAeE;;EACC,uBAAA;EACA,iCAAA;EACA,4BAAA;AAZH;AAcG;;EACC,uBAAA;EACA,iCAAA;AAXJ;;AAgBA;EACC,aAAA;EACA,iBAAA;AAbD;AA9QC;EAyRD;IAIE,cAAA;EAXA;AACF;AAaC;EACC,iBAAA;EACA,2BAAA;EACA,+CAAA;EACA,mBAAA;AAXF;;AAcA;EACC,aAAA;AAXD;AAvRC;EAiSD;IAGE,cAAA;EATA;AACF;;AAlSC;EA6SD;IAEE,kBAAA;IACA,qBAAA;EARA;AACF;;AAcA;EACC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;AAXD;;AAeA;EACC,sBAAA;EACA,yBAAA;EACA,gBAAA;EACA,0BAAA;EACA,wCAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;AAZD;;AAeA;EACC,eAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,6BAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;AAZD;AAcC;EACC,yBAAA;AAZF;AAeC;EACC,WAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,4FAAA;EACA,qBAAA;AAbF;AAgBC;EACC,gCAAA;AAdF;AAiBC;EACC,eAAA;EACA,kBAAA;EACA,WAAA;AAfF;;AAqBA;EACC,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;EACA,0BAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAlBD;;AAqBA;EACC,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,0CAAA;AAlBD;AAoBC;EACC,oCAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;AAlBF;AAqBC;EACC,uCAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AAnBF;AAsBC;EACC,WAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,oCAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;AApBF;AAuBC;EACC,mBAAA;EACA,YAAA;AArBF;AAuBE;EACC,YAAA;AArBH;AAyBC;EACC,iBAAA;EACA,cAAA;EACA,yBAAA;AAvBF;AAyBE;EACC,yBAAA;AAvBH;;AA4BA;EACC,yBAAA;EACA,kBAAA;EACA,kBAAA;EAEA,kBAAA;EACA,gBAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;EAUA,gDAAA;AApCD;AA4BC;EACC,eAAA;EACA,kBAAA;EACA,WAAA;EACA,0BAAA;EACA,SAAA;AA1BF;AA8BC;EACC,WAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,iBAAA;EACA,mBAAA;EACA,yDAAA;EACA,+BAAA;AA5BF","sourcesContent":["@mixin desktop {\n\t@media (min-width: 991px) {\n\t\t@content;\n\t}\n}\n\n@mixin mobile {\n\t@media (max-width: 992px) {\n\t\t@content;\n\t}\n}\n\n:host {\n\tuser-select: text;\n\t-webkit-user-select: text;\n}\n\n.close-icon {\n\tposition: absolute;\n\ttop: 10px;\n\tright: 10px;\n}\n\n.hero {\n\tpadding: 30px 25px 25px;\n\tcolor: var(--ion-color-main);\n\ttext-align: left;\n\th1 {\n\t\tfont-family: AppFontSemiBold, sans-serif;\n\t\tfont-size: 22px;\n\t\tline-height: 33px;\n\t\ttext-transform: uppercase;\n\t\tmargin: 10px 0px 5px;\n\t}\n\tp {\n\t\tfont-family: AppFontLight, sans-serif;\n\t\tcolor: rgba(47, 51, 58, 0.7);\n\t\tfont-size: 14px;\n\t\tmargin-top: 5px;\n\t\tmargin-bottom: 15px;\n\t}\n}\n\n.search-bar ion-input {\n\tcolor: var(--ion-color-main) !important;\n\t--color: var(--ion-color-main);\n\tfont-size: 15px !important;\n\tfont-weight: 600; /* Make text bolder */\n\t--padding-top: 20px;\n\t--padding-bottom: 20px;\n\t--padding-start: 10px;\n\t--padding-end: 10px;\n\n\t/* Styles for the host interaction */\n\tuser-select: text !important;\n\t-webkit-user-select: text !important;\n\n\t/* Target the native input inside Shadow DOM */\n\t&::part(native) {\n\t\tcaret-color: #474030 !important; /* Use dark color from theme instead of light primary */\n\t\tcaret-width: 2px !important; /* Make caret thicker */\n\t\tuser-select: text !important;\n\t\t-webkit-user-select: text !important;\n\t\tpointer-events: auto !important;\n\t\topacity: 1 !important;\n\t\tfont-weight: 600 !important;\n\t}\n}\n.search-bar {\n\tborder: 1px solid #e5e5e5;\n\tborder-radius: 7px;\n\t--background: #ffffff;\n\tbackground: #ffffff;\n\toverflow: hidden;\n\ttransition:\n\t\tborder-color 0.2s,\n\t\tbox-shadow 0.2s;\n\n\t/* Layout replacement */\n\tdisplay: flex;\n\talign-items: center;\n\tpadding-left: 10px;\n\tpadding-right: 10px;\n\n\t&:focus-within {\n\t\tborder-color: var(--ion-color-primary);\n\t\tbox-shadow: 0 0 0 1px var(--ion-color-primary);\n\t}\n}\n\n.search-bar ion-input {\n\tflex: 1;\n\t--background: transparent;\n}\n\n.start-icon {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tmargin-right: 5px;\n\t/* Reset other margins if needed */\n\tmargin-inline-end: 5px;\n}\n\n.search-container ion-col {\n\tpadding: 0 !important;\n\tborder-radius: var(--ion-border-radius);\n}\n\n.no-place {\n\tpadding: 16px 9px;\n\tfont-family: AppFont-bold, sans-serif;\n\tbackground: #ffffff;\n\tbox-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n\tborder-radius: var(--ion-border-radius);\n\tfont-size: 12px;\n\tline-height: 131.5%;\n}\n\n.suggested-place {\n\tborder-radius: 7px;\n\tborder: 1px solid #d5dddd;\n\tbackground: #f7f9f9;\n\tplace-items: center;\n\tpadding: 15px 20px;\n\tmargin-top: 5px;\n\ttext-align: left;\n\t.navigate-icon {\n\t\tmargin-right: 15px;\n\t\tfill: var(--ion-color-primary) !important;\n\t}\n\n\t.actual-position-title {\n\t\tfont-size: 14px;\n\t\tline-height: 17px;\n\t\ttext-transform: uppercase;\n\t\tcolor: var(--ion-color-primary);\n\t\tfont-family: AppFontSemiBold, sans-serif;\n\t}\n\n\t.actual-position {\n\t\tfont-size: 13px;\n\t\tmargin-top: 5px;\n\t\tline-height: 16px;\n\t\tcolor: #6d7075;\n\t\tfont-family: AppFontLight, sans-serif;\n\t}\n}\n\n#buttonContainer {\n\tposition: absolute;\n\twidth: 100%;\n\tbottom: 0;\n}\n\n.vertical-space-around {\n\theight: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-around;\n\talign-items: center;\n}\n\n.cnt-btn {\n\twidth: 100%;\n\tpadding: 16px;\n\ttext-align: center;\n\tfont-family: AppFontBold, sans-serif;\n\tcolor: white;\n\tfont-weight: bold;\n\n\ttext-transform: uppercase;\n\tcursor: pointer;\n\tmargin: 0;\n\tbackground: var(--randy-red, #dd2e4e) !important;\n\tcolor: white !important;\n\tborder: none;\n\tbox-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n\tborder-radius: 50px;\n\t@include desktop {\n\t\tmargin: auto;\n\t}\n}\n\n.geo-btn {\n\tbackground: #62aba4;\n\tfont-family: AppFont-bold, sans-serif;\n\tcolor: #ffffff;\n\tfont-weight: bold;\n\tcursor: pointer;\n\twidth: 100%;\n\tpadding: 16px;\n\ttext-align: center;\n\n\ttext-transform: uppercase;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\n\tion-icon {\n\t\twidth: 22px;\n\t\theight: 25px;\n\t\tmargin-right: 10px;\n\t}\n\n\t@include desktop {\n\t\twidth: 600px;\n\t\tmargin: auto;\n\t}\n}\n\n.heading-text {\n\tfont-size: 19px;\n\tcolor: var(--ion-text-color);\n\tfont-weight: 500;\n\tline-height: 145%;\n\tmargin: 20px 0 10px;\n\n\t&.desktop {\n\t\tdisplay: block;\n\t\t@include mobile() {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t&.mobile {\n\t\tdisplay: none;\n\t\t@include mobile() {\n\t\t\tdisplay: block;\n\t\t}\n\t}\n}\n\n.sub-heading {\n\tfont-size: 18px;\n\tline-height: 134%;\n\tmargin: 0;\n}\n\n.footer-btn {\n\tfont-family: AppFontBold, sans-serif;\n\ttext-transform: uppercase;\n\tcolor: white;\n}\n\nion-footer,\n.footer-btn {\n\tbackground: unset;\n\tpadding: 5px 28px 25px !important;\n\tbox-shadow: none;\n\n\t@include desktop {\n\t\tmargin: 0px 50px 0 !important;\n\t\twidth: calc(100% - 100px) !important;\n\t}\n\n\t.button {\n\t\tflex: 1;\n\t\tbackground: var(--ion-color-primary) !important;\n\t\tcolor: white !important;\n\t\ttext-align: center;\n\n\t\t&:first-child {\n\t\t\tmargin-right: 3px;\n\t\t}\n\n\t\t&:last-child {\n\t\t\tmargin-left: 3px;\n\t\t}\n\n\t\t&.active {\n\t\t\ttransition: 0.3s linear;\n\t\t\tbackground: var(--ion-color-main);\n\t\t\tcolor: var(--ion-text-color);\n\n\t\t\t&:hover {\n\t\t\t\ttransition: 0.3s linear;\n\t\t\t\tbackground: var(--ion-color-main);\n\t\t\t}\n\t\t}\n\t}\n}\n.desktop {\n\tdisplay: none;\n\tmargin: 50px 25px;\n\t@include desktop() {\n\t\tdisplay: block;\n\t}\n\n\t.hero {\n\t\tbackground: white;\n\t\tborder: 0.5px solid #e5e5e5;\n\t\tbox-shadow: 0px 4px 10px rgba(33, 33, 33, 0.02);\n\t\tborder-radius: 10px;\n\t}\n}\n.mobile {\n\tdisplay: none;\n\t@include mobile() {\n\t\tdisplay: block;\n\t}\n}\n.desktop-hero {\n\t@include desktop() {\n\t\ttext-align: center;\n\t\tmargin: 0px 25px 50px;\n\t}\n}\n// .cross {\n//   fill: var(--ion-color-primary) !important;\n// }\n\n.cross-icon-close {\n\tposition: absolute;\n\ttop: 10px;\n\tright: 10px;\n\tcursor: pointer;\n}\n\n// Autocomplete Dropdown Styles\n.pac-container {\n\tbackground-color: #fff;\n\tborder: 1px solid #d5dddd;\n\tborder-top: none;\n\tborder-radius: 0 0 7px 7px;\n\tbox-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n\tmargin-top: -2px;\n\tposition: relative; // Or absolute if needed, but relative works in the flow here\n\tz-index: 100;\n}\n\n.pac-item {\n\tcursor: pointer;\n\tpadding: 10px 15px;\n\ttext-overflow: ellipsis;\n\toverflow: hidden;\n\twhite-space: nowrap;\n\tline-height: 30px;\n\ttext-align: left;\n\tborder-top: 1px solid #e6e6e6;\n\tfont-size: 14px;\n\tcolor: #333;\n\tdisplay: flex;\n\talign-items: center;\n\n\t&:hover {\n\t\tbackground-color: #fafafa;\n\t}\n\n\t.pac-icon {\n\t\twidth: 15px;\n\t\theight: 20px;\n\t\tmargin-right: 7px;\n\t\tmargin-top: -1px;\n\t\tdisplay: inline-block;\n\t\tvertical-align: top;\n\t\tbackground-image: url(https://maps.gstatic.com/mapfiles/api-3/images/autocomplete-icons.png);\n\t\tbackground-size: 34px;\n\t}\n\n\t.pac-icon-marker {\n\t\tbackground-position: -1px -161px;\n\t}\n\n\t.pac-item-query {\n\t\tfont-size: 14px;\n\t\tpadding-right: 3px;\n\t\tcolor: #000;\n\t}\n}\n\n// Custom styles for radius alert\n\n.overlay-backdrop {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n\tbackground: rgba(0, 0, 0, 0.53);\n\tbackdrop-filter: blur(5px);\n\tz-index: 1000;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n.radius-alert-card {\n\tbackground: #fffaf1;\n\tborder-radius: 6px;\n\tpadding: 24px;\n\twidth: 90%;\n\tmax-width: 400px;\n\ttext-align: center;\n\tbox-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n\n\th2 {\n\t\tfont-family: AppFontBold, sans-serif;\n\t\tfont-size: 20px;\n\t\tcolor: #1f2228;\n\t\tmargin-bottom: 12px;\n\t\tmargin-top: 0;\n\t}\n\n\tp {\n\t\tfont-family: AppFontRegular, sans-serif;\n\t\tfont-size: 12px;\n\t\tline-height: 140%;\n\t\tcolor: #1f2228;\n\t\tmargin-bottom: 24px;\n\t}\n\n\tbutton {\n\t\twidth: 100%;\n\t\tpadding: 14px;\n\t\tmargin-bottom: 12px;\n\t\tborder-radius: 4px;\n\t\tfont-family: AppFontBold, sans-serif;\n\t\tfont-size: 16px;\n\t\tcursor: pointer;\n\t\tborder: none;\n\t\toutline: none;\n\t}\n\n\t.btn-pickup {\n\t\tbackground: #dc3545; // Adjust to exact design red if needed\n\t\tcolor: white;\n\n\t\t&:active {\n\t\t\topacity: 0.9;\n\t\t}\n\t}\n\n\t.btn-cancel {\n\t\tbackground: white;\n\t\tcolor: #1f2228;\n\t\tborder: 1px solid #c4c4c4;\n\n\t\t&:active {\n\t\t\tbackground-color: #f9f9f9;\n\t\t}\n\t}\n}\n\n.error-row {\n\tbackground-color: #ed6958;\n\tpadding: 16px 35px;\n\tborder-radius: 5px;\n\n\tposition: relative;\n\tmargin-top: 12px;\n\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\n\t.error-message {\n\t\tfont-size: 14px;\n\t\ttext-align: center;\n\t\tcolor: #fff;\n\t\ttext-transform: capitalize;\n\t\tmargin: 0;\n\t}\n\n\t/* Add the little arrow (triangle) pointing up */\n\t&::before {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\ttop: -16px;\n\t\tleft: 50%;\n\t\tborder-width: 8px;\n\t\tborder-style: solid;\n\t\tborder-color: transparent transparent #e85c4a transparent;\n\t\ttransform: translate(-50%, 0px);\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
